var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .arrow-background {\n        fill: #b1b2b4;\n      }\n\n      .arrow-line {\n        fill: #50535a;\n      }\n    ")),React.createElement("title",{"key":1},"arrow"),React.createElement("g",{"data-name":"arrow","key":2},[React.createElement("polygon",{"className":"arrow-background","points":"302 60 5 60 14 30 5 0 302 0 311 30 302 60","key":0}),React.createElement("polygon",{"className":"arrow-line","points":"6 60 0 60 9 30 0 0 6 0 15 30 6 60","key":1})])]);
}

Arrow.defaultProps = {"viewBox":"0 0 311 60","preserveAspectRatio":"none","className":"arrow"};

module.exports = Arrow;

Arrow.default = Arrow;
